module.exports = __webpack_public_path__ + "img/communities.87a161ee.svg";